import { render, staticRenderFns } from "./client-archive.vue?vue&type=template&id=f14bfae8&scoped=true&"
import script from "./client-archive.vue?vue&type=script&lang=ts&"
export * from "./client-archive.vue?vue&type=script&lang=ts&"
import style0 from "./client-archive.vue?vue&type=style&index=0&id=f14bfae8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14bfae8",
  null
  
)

component.options.__file = "client-archive.vue"
export default component.exports